import HCLTreeVertexValue, {HCLTreeVertexValueJSON} from '../../HCLTreeVertexValue/HCLTreeVertexValue';
import { Label, LabelJSON } from "../../HCLTreeVertexValue/Label";
import Outcome, {OutcomeJSON} from "../../HCLTreeVertexValue/Outcome";

interface InitVertexValueJSON extends HCLTreeVertexValueJSON {
  outcome: OutcomeJSON;
}

class InitVertexValue extends HCLTreeVertexValue {

  private outcome: Outcome;

  /**
   * @param {Label} label
   * @param {Outcome} outcome
   */
  constructor(label?: Label, outcome?: Outcome) {
    super(label || new Label("Initiating Event", ""));
    this.outcome = outcome;
  }

  /**
   * @return {Outcome}
   */
  getOutcome(): Outcome {
    return this.outcome;
  }

  /**
   * @param {Outcome} outcome
   */
  setOutcome(outcome: Outcome): void {
    this.outcome = outcome;
  }

  /**
   * @override
   * @return {InitVertexValueJSON} - dictionary object that describes this
   */
  toJSON(): InitVertexValueJSON | HCLTreeVertexValueJSON {

    if (this.outcome) {
      return ({
        ...super.toJSON(),
        outcome: this.outcome.toJSON()
      });
    }

    return super.toJSON();
  }

  clone(): InitVertexValue {
    return new InitVertexValue(this.label.clone(), this.outcome.clone());
  }
}

export default InitVertexValue;
export { InitVertexValue, InitVertexValueJSON };
